module.exports = __webpack_public_path__ + "media/camping_m2.8f98c94b.mp4";